import dayjs from "dayjs";

export const lastTwentyFourHoursDateRange = () => {
  const defaultStartDate = dayjs()
    .subtract(24, "hours")
    .format("YYYY-MM-DD HH:mm:ss");
  const defaultEndDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
  const dateRange = {
    start_date: defaultStartDate,
    end_date: defaultEndDate,
  };
  return dateRange;
};
